import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=3b41546b&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"
import style0 from "./Test.vue?vue&type=style&index=0&id=3b41546b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../Retirement Planner.Admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b41546b",
  null
  
)

export default component.exports